"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSyncGamblerSettings = void 0;
var lodash_1 = require("lodash");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/concatMap");
require("rxjs/add/observable/empty");
require("rxjs/add/observable/from");
var Observable_1 = require("rxjs/Observable");
var core_1 = __importDefault(require("@gin-betting/core"));
var persist_1 = require("@gin-betting/persist");
var actions_1 = require("./actions");
var utils_1 = require("./utils");
var getBettingOptions = core_1.default.utils.getBettingOptions, appServiceLocator = core_1.default.appServiceLocator;
function makeSyncGamblerSettings(gamblerSettingsMapping) {
    var supportRehydrateKeys = lodash_1.keys(gamblerSettingsMapping);
    return function (actions$) {
        var isAuthorized = getBettingOptions().isAuthorized;
        if (!isAuthorized)
            return Observable_1.Observable.empty();
        var gamblerObservable = Observable_1.Observable.from(appServiceLocator.get('apiClient').makeRequest({
            method: 'getGambler',
            variables: {},
        }));
        return actions$
            .ofType(persist_1.REHYDRATE)
            .filter(function (_a) {
            var rehydrateKey = _a.key;
            return supportRehydrateKeys.includes(rehydrateKey);
        })
            .mergeMap(function (action) {
            return gamblerObservable
                .map(function (_a) {
                var data = _a.data;
                var actions = [];
                var rehydrateKey = action.key, payload = action.payload;
                var paths = gamblerSettingsMapping[rehydrateKey];
                // NOTE: rehydrateKey instanced of gamblerSettingsMapping. Method from above filter unsupported rehydrateKey/
                if (!paths)
                    return actions;
                var serverSettings = utils_1.convertResponseToClientSettings(data);
                var clientSettings = lodash_1.mapValues(paths, function (path) { return lodash_1.get(payload, path); });
                var _b = lodash_1.reduce(clientSettings, function (acc, clientValue, reducerPropKey) {
                    var serverValue = serverSettings[reducerPropKey];
                    if (serverValue === undefined && clientValue) {
                        acc.toServer[reducerPropKey] = clientValue;
                    }
                    else if (!lodash_1.isEqual(clientValue, serverValue)) {
                        acc.fromServer[reducerPropKey] = serverValue;
                    }
                    return acc;
                }, {
                    toServer: {},
                    fromServer: {},
                }), fromServer = _b.fromServer, toServer = _b.toServer;
                if (!lodash_1.isEmpty(toServer)) {
                    actions.push(actions_1.changeGamblerSettings(toServer));
                }
                if (!lodash_1.isEmpty(fromServer)) {
                    var rehydrateAction_1 = action;
                    lodash_1.forEach(fromServer, function (value, reducerPropKey) {
                        rehydrateAction_1 = lodash_1.set(rehydrateAction_1, "payload." + paths[reducerPropKey], value);
                    });
                    actions.push(rehydrateAction_1);
                }
                return actions;
            })
                .concatMap(function (a) { return a; });
        });
    };
}
exports.makeSyncGamblerSettings = makeSyncGamblerSettings;
//# sourceMappingURL=epics.js.map